import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { CART_QUERY_KEYS } from '~/utils/cartCache';
import { PLATFORM_PRODUCT_QUERY_KEY } from './platformProducts';

export const useUpsertProductVehicleCapacity = () => {
  const mutation = graphql(`
    mutation UpsertProductVehicleCapacity(
      $platformProductLengthId: ID!
      $transportVehicleId: ID!
      $capacity: QuantityInput!
    ) {
      upsertProductVehicleCapacity(
        platformProductLengthId: $platformProductLengthId
        transportVehicleId: $transportVehicleId
        capacity: $capacity
      ) {
        id
      }
    }
  `);

  return useGraphqlMutation(mutation, [
    ...CART_QUERY_KEYS,
    'shippingCost',
    PLATFORM_PRODUCT_QUERY_KEY,
    'buyerInventories',
  ]);
};
